import { render, staticRenderFns } from "./EducationalGroup.vue?vue&type=template&id=21601149"
import script from "./EducationalGroup.vue?vue&type=script&lang=js"
export * from "./EducationalGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports